import { Badge, type BadgeTone } from '@fiveox/ui'

import { type StatusKind, statusTone } from './status'

export interface StatusBadgeProps {
  kind: StatusKind
  status: string | null | undefined
  /** The words, when the screen has better ones than the map — a case's own
   *  stage name over its category, say. The tone still comes from the map. */
  label?: string
  /** Only for a tone the status alone cannot decide (an import committed with
   *  refusals). Say why at the call site. */
  tone?: BadgeTone
  size?: 'sm' | 'md'
}

/** The one status pill: `statusTone` drawn as the kit's `Badge`. */
export function StatusBadge({ kind, status, label, tone, size = 'sm' }: StatusBadgeProps) {
  const found = statusTone(kind, status)
  return (
    <Badge tone={tone ?? found.tone} size={size}>
      <span data-status={status ?? ''}>{label ?? found.label}</span>
    </Badge>
  )
}
